<template>
  <base-layout :withHeaderStructure="true" v-if='broadcast'>
    <template v-slot:header>
      <nav>
        <button @click="handleBackToBroadcasts" class="flex items-center text-sm leading-5 font-medium text-gray-400 hover:text-gray-200">
          <svg class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg> Back to broadcasts
        </button>
      </nav>
      <div class="mt-1 mb-2 md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0 mt-2 ">
          <h3 class='leading-7 text-gray-400 text-xl leading-9 sm:truncate tracking-tight'>
            {{ broadcast.broadcastListName }} Broadcast, {{ broadcast.dateAsString }}
          </h3>
          <h1 class="font-bold leading-7 text-gray-900 text-2xl sm:text-3xl leading-9 sm:truncate tracking-tight">
            {{ broadcast.subject }}</h1>
        </div>

        <div v-if='user && user.isServiceOnly===0' class="mt-4 flex md:mt-0 md:ml-4">
          <button @click='showReplyModal' type="button" class="btn btn-primary">Reply to Broadcast</button>
        </div>

      </div>

    </template>
    <template v-slot:main>
      <div>
        <div v-if="!user" class='mb-6 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700 block'>
          <!-- <a href='javascript:void(0)' @click="toFreeTrialPage" class='hover:underline'>Please register here for your free trial to see full broadcast details!</a> -->
          <a href='javascript:void(0)' @click="toFreeTrialPage" class='hover:underline'>Please register here to see full broadcast details!</a>
        </div>
        <div class="grid grid-cols-12 gap-6 mt-6 sm:mt-0">
          <div class="col-span-12 lg:col-span-12 bg-white shadow overflow-hidden sm:rounded-lg">
            <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
              <div class="grid grid-cols-2">
                <div class="text-left flex-col gap-3">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">Broadcast Details</h3>
                </div>
                <div v-if='settingsMap.enableBroadcastShareButtons == 1 && isOwnBroadcast'
                    class='grid grid-cols-3 gap-2 ml-auto mr-0'>
                  <div>
                    <a :href="'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent('https://news.thebrokersite.com/?id='+broadcast.id+'&bc=1&share=facebook')"
                      target="_blank" rel="noopener" title="Share on Facebook">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30" height="30" viewBox="0 0 256 256" xml:space="preserve">
                    <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                      <path
                          d="M 85.033 90 C 87.776 90 90 87.776 90 85.033 V 4.967 C 90 2.223 87.776 0 85.033 0 H 4.967 C 2.223 0 0 2.223 0 4.967 v 80.066 C 0 87.776 2.223 90 4.967 90 H 85.033 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(60,90,153); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                      <path
                          d="M 50.916 83.204 V 48.351 h 11.699 l 1.752 -13.583 h -13.45 v -8.672 c 0 -3.933 1.092 -6.612 6.731 -6.612 l 7.193 -0.003 V 7.332 c -1.244 -0.166 -5.513 -0.535 -10.481 -0.535 c -10.37 0 -17.47 6.33 -17.47 17.954 v 10.017 H 25.16 v 13.583 h 11.729 v 34.853 H 50.916 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                    </g>
                    </svg>
                    </a>
                  </div>

                  <div>
                    <a :href="'https://www.linkedin.com/shareArticle?mini=true&url='+encodeURIComponent('https://news.thebrokersite.com/?id='+broadcast.id+'&bc=1&share=linkedin')"
                      target="_blank" rel="noopener" title="Share on LinkedIn">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30" height="30" viewBox="0 0 256 256" xml:space="preserve">
                    <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                      <path
                          d="M 0 6.447 C 0 2.887 2.978 0 6.651 0 h 76.698 C 87.022 0 90 2.887 90 6.447 v 77.106 C 90 87.114 87.022 90 83.349 90 H 6.651 C 2.978 90 0 87.114 0 83.553 V 6.447 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,102,153); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                      <path
                          d="M 20.485 29.151 c 4.74 0 7.691 -3.121 7.691 -7.021 c -0.088 -3.988 -2.95 -7.022 -7.601 -7.022 c -4.65 0 -7.69 3.034 -7.69 7.022 c 0 3.9 2.95 7.021 7.512 7.021 H 20.485 L 20.485 29.151 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                      <path d="M 27.282 75.339 v -40.64 H 13.688 v 40.64 H 27.282 z"
                            style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;"
                            transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                      <path
                          d="M 34.804 75.339 h 13.594 V 52.644 c 0 -1.215 0.088 -2.428 0.447 -3.296 c 0.983 -2.427 3.219 -4.94 6.975 -4.94 c 4.919 0 6.887 3.727 6.887 9.19 v 21.741 h 13.592 V 52.037 c 0 -12.483 -6.706 -18.291 -15.65 -18.291 c -7.333 0 -10.553 4.073 -12.342 6.847 h 0.091 v -5.894 H 34.804 C 34.982 38.513 34.804 75.339 34.804 75.339 L 34.804 75.339 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                    </g>
                    </svg>
                    </a>
                  </div>

                  <div>
                    <a :href="'https://twitter.com/intent/tweet?text=' + encodeURIComponent(broadcast.subject) + '+' + encodeURIComponent('https://news.thebrokersite.com/?id='+broadcast.id+'&bc=1&share=x')"
                      target="_blank" rel="noopener" title="Share on X (Twitter)">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30" height="30" viewBox="0 0 256 256" xml:space="preserve">
                    <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                      <polygon points="24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01 "
                              style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                              transform="  matrix(1 0 0 1 0 0) "/>
                      <path
                          d="M 0 0 v 90 h 90 V 0 H 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z"
                          style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                          transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
                    </g>
                    </svg>
                    </a>
                  </div>
                </div>
                <div v-else class="flex flex-row-reverse">
                  <button v-if="user && broadcast.side == 'WTS'" @click='goToCreatePurchaseOrder' type="button"
                    class="hidden md:inline-block w-40 sm:w-36 text-sm text-center btn btn-muted text-red-700 border-red-700 hover:text-red-700 sm:mt-0 mt-3 mx-2">
                    Purchase Order
                  </button>
                  <template v-if="user">
                    <img v-if="user"
                      @click="navToEscrow()"
                      src="/img/escrow_button.png"
                      alt="Escrow Button"
                      title="Initiate Escrow.com Deal"
                      class="hidden sm:block h-8 w-auto cursor-pointer"
                    />
                    <p class="hidden sm:block mx-2 mt-1 font-bold">Start deal on </p>
                  </template>
                </div>
                <!-- <div class="text-right">
                <h3 v-if='!companyIsFavorite'><a href='javascript:void(0)' @click="setCompAsFavorite(true)" class='text-red-600 hover:underline'>Add {{broadcast.company.name}} to your favorites</a></h3>
                <h3 v-else class="text-right"><a href='javascript:void(0)' @click="setCompAsFavorite(false)" class='text-red-600 hover:underline'>Remove {{broadcast.company.name}} from your favorites</a></h3>
              </div> -->
              </div>
              <div v-if="user" class="sm:hidden mt-6">
                <div class="flex justify-between items-center" @click="navToEscrow()">
                  <p class="mr-2">Start deal on</p>
                  <img
                    src="/img/escrow_button.png"
                    alt="Escrow Button"
                    title="Initiate Escrow.com Deal"
                    class="h-10 w-auto cursor-pointer"
                  />
                </div>

                <div v-if="user && broadcast.side == 'WTS'" class="mt-3">
                  <button @click="goToCreatePurchaseOrder()" class="border border-red-700 text-red-700 px-4 py-2 rounded-md w-full">
                    Purchase Order
                  </button>
                </div>
              </div>
            </div>
            
            <div v-if="user && broadcastImages && broadcastImages.length">
              <div class="flex gap-3 sm:gap-4 flex-wrap justify-left items-left px-4 mt-6">
                <img
                  v-for="(img, index) in broadcastImages"
                  :key="index"
                  :src="imageSrc(img)"
                  class="w-36 sm:w-32 h-24 object-contain bg-gray-100 rounded-lg border cursor-pointer hover:scale-105 transition"
                  @click="openModal(imageSrc(img), index)"
                />
              </div>
            </div>


            <div class='px-6 my-6'>
              <div v-html="broadcast.messageFormatted" class="break-words"></div>
              <!-- <dl class='mt-2 mb-4'>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Broadcast List</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.broadcastListName}}
                  </dd>
                </div>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Quantity</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.quantity}}
                  </dd>
                </div>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Brand</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.brand}}
                  </dd>
                </div>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Description</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.description}}
                  </dd>
                </div>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Condition</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.condition}}
                  </dd>
                </div>
                <div class=" px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-4">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Price</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 lg:col-span-3">
                    {{broadcast.price}}
                  </dd>
                </div>
              </dl> -->
            </div>
          </div>

        </div>

        <modal v-if='user' v-show="doShowReplyModal" @submit="submitReply" @cancel="closeReplyModal"
               header="Reply to broadcast"
               customCssClasses="sm:max-w-2xl"
               affirmativeButtonLabel='Send'>
          <template v-slot:body>
            <div>
              <ValidationObserver ref="sendMessageObserver">
                <dl class='mt-4 mb-4 sm:-ml-6 sm:-mr-6'>
                  <div class=" py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt class="text-sm leading-5 font-medium text-gray-500">To</dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                        <span v-if="broadcast.company">{{ broadcast.company.name }}</span><br/>
                        <span v-if="broadcast.contact">{{ broadcast.contact.name }} ({{ broadcast.contact.email }})</span>
                      </dd>
                  </div>
                  <div class=" py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt class="text-sm leading-5 font-medium text-gray-500">From</dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                      <div>{{ user.name }} ({{ user.email }})</div>
                      <div>{{ user.companyName }}</div>
                    </dd>
                  </div>
                  <div class=" py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt class="text-sm leading-5 font-medium text-gray-500">Telephone</dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                      {{ user.tel }}
                    </dd>
                  </div>
                  <div class=" py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
                    <dt class="text-sm leading-9 font-medium text-gray-500">Subject</dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                      <ValidationProvider name="Subject" rules="required" v-slot="{ errors }">
                        <input class="form-input block w-full" placeholder="Reply Subject"
                               v-model="broadcastReplySubject">
                        <span class='text-red-500 text-sm mt-1 block'>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </dd>
                  </div>
                  <div class='mt-4 sm:ml-6 sm:mr-6'>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <textarea rows="12" class="form-input block w-full" placeholder="Reply Body"
                                v-model="broadcastReplyBody"></textarea>
                      <span class='text-red-500 text-sm mt-1 block'>{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </dl>
              </ValidationObserver>
            </div>
          </template>
        </modal>


        <!-- Modal -->
        <div v-if="showModal" ref="modalWrapper" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="closeModal">
          <div class="relative bg-white rounded-xl p-6 shadow-2xl w-9/12 max-w-8xl min-h-[700px] h-[85vh] flex items-center justify-center overflow-hidden"
              :style="{ minHeight: screenWidth < 640 ? '300px' : '500px', maxHeight: '85vh' }">

            <!-- Close Button -->
            <button class="absolute top-2 right-2 text-white bg-red-500 px-2 rounded-lg text-xl z-50 font-semibold" @click="closeModal">
              ✕
            </button>
            <button
              v-if="broadcastImages && broadcastImages.length > 1"
              @click.stop="prevImage"
              class="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white text-3xl px-3 py-1 rounded-full z-50 hover:bg-opacity-75"
            >
              ‹
            </button>

            <!-- Right Button -->
            <button
              v-if="broadcastImages && broadcastImages.length > 1"
              @click.stop="nextImage"
              class="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white text-3xl px-3 py-1 rounded-full z-50 hover:bg-opacity-75"
            >
              ›
            </button>
            <!-- Image Wrapper -->
            <div  v-show="imageReady" class="flex items-center justify-center w-full h-full min-h-[500px]">
              <img
                ref="zoomImage"
                :src="selectedImage"
                class="max-h-full max-w-full select-none cursor-grab cursor-pointer"
                :style="imageStyle"
                @wheel="handleZoom"
                @mousedown="startDrag"
                @mousemove="onDrag"
                @mouseup="stopDrag"
                @mouseleave="stopDrag"
                @load="resetImageScale"
                draggable="false"
              />
            </div>

            <!-- Legend/Instructions -->
            <div class="absolute bottom-4 left-4 text-white text-xs rounded-lg px-3 py-2 z-50 flex flex-col gap-2" style="background-color: rgba(0, 0, 0, 0.6);">
              <!-- Reset -->
              <div @click.stop="resetView" class="flex items-center gap-1 cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>Reset</span>
              </div>
              
              <!-- Instructions -->
              <div class="hidden md:flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
                </svg>
                <span>Use <kbd class="px-1 py-0.5 bg-white bg-opacity-20 rounded text-xs text-black">Ctrl</kbd> and scroll to zoom in and out</span>
              </div>
              <div class="hidden md:flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3.5M6 11V9.5a1.5 1.5 0 013 0V11" />
                </svg>
                <span>Click and drag the image to move around</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </template>
  </base-layout>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import BaseLayout from '@/components/BaseLayout.vue'
import Modal from '@/components/modal.vue'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { useSchemaOrg } from '../composables/useSchema.org.js';

import store from '../store'
import eventBus from '../utils/eventBus'
import axios from 'axios'

const _ = require('lodash');

extend('required', {
  ...required,
  message: 'This field is required'
});

export default {
  name: 'CompanyDetail',
  components: {
    BaseLayout,
    Modal,
    ValidationProvider,
    ValidationObserver,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const resp = await store.dispatch('getBroadcast', to.params.id)
      if (resp.status !== 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Broadcast removed",
          body: resp.msg,
          timeoutInMS: 5000,
        })
        return;
      }
      next(vm => {
        vm.broadcast = resp.broadcast
        const subject = vm.broadcast.subject.length > 60 
          ? vm.broadcast.subject.substring(0, 57) + '...' 
          : vm.broadcast.subject;
        document.title = `${subject} - The Broker Site`
        vm.addBroadcastDetailSchema();

        const parentId = to.query.parentId;

        if (parentId) {
          sessionStorage.setItem('parentId', parentId);

          // remove from URL cleanly
          vm.$router.replace({
            path: to.path,
            params: to.params,
            query: {}
          });
        }


      })
    } catch (e) {
      console.log("err", e)
    }
  },
  created() {
    this.companyIsFavorite = this.user? this.user.favCompanies.includes(this.broadcast?.companyId) : false;
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('keydown', this.handleKeydown);
    this.isOwnBroadcast = this.broadcast.contactId === this.user?.id
    this.fetchImages();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('keydown', this.handleKeydown);
  },
  data() {
    return {
      broadcast: null,
      doShowReplyModal: false,
      broadcastReplySubject: null,
      broadcastReplyBody: null,
      companyIsFavorite: false,
      enableShareButtons: true,
      isOwnBroadcast: false,
      broadcastImages: [],
      allowedUsers: ['24116', '1560'],

      showModal: false,
      selectedImage: null,

      scale: 1,
      minScale: 0.1,
      maxScale: 5,

      isDragging: false,
      startX: 0,
      startY: 0,
      translateX: 0,
      translateY: 0,
      screenWidth: window.innerWidth, 
      skipTransition: false,
      imageReady: false,
      currentIndex: 0,
    }
  },
  computed: {
    ...mapState(["route", 'user', 'lastSearch', 'settingsMap']),
    imageStyle() {
      return {
        transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`,
        transition: this.isDragging || this.skipTransition ? "none" : "transform 0.1s ease",
      };
    },
  },

  methods: {
    ...mapActions(["sendBroadcastReply", 'setAsFavorite']),
    cleanupOldHeartbeats() {
      const now = Date.now();

      Object.keys(localStorage).forEach((key) => {
        if (!key.startsWith('tab_alive_')) return;

        const last = Number(localStorage.getItem(key));

        if (now - last > 5 * 60 * 1000) {
          localStorage.removeItem(key);
        }
      });
    },
    handleBackToBroadcasts() {
      const parentId = sessionStorage.getItem('parentId');

      this.cleanupOldHeartbeats();

      const lastSeen = localStorage.getItem(`tab_alive_${parentId}`);
      const isParentAlive = lastSeen && (Date.now() - lastSeen < 3000); // 3 seconds

      if (isParentAlive) {
        // parent still open just close child
        window.close();
        return;
      } else {
        sessionStorage.removeItem('parentId');
        sessionStorage.removeItem('tabId');

        // parent dead go to broadcasts page
        this.$router.push({ name: 'broadcasts'}); 
      }
    },
    stripTextFromHtml(htmlString) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || htmlString;
    },
    showReplyModal() {
      this.broadcastReplySubject = `Re: ${this.broadcast.subject}`
      this.broadcastReplyBody = `${this.user.signature}===================================================\nOriginal message from ${this.broadcast.contact.email}:\n\n${this.stripTextFromHtml(this.broadcast.message)}`
      this.doShowReplyModal = true;
    },
    async submitReply() {

      const isValid = await this.$refs.sendMessageObserver.validate();
      if (!isValid) return;

      const payload = {
        broadcastId: this.broadcast.id,
        subject: this.broadcastReplySubject,
        body: this.broadcastReplyBody,
      }

      const resp = await this.sendBroadcastReply(payload);

      if (resp.data.status !== 200) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: "Message delivery failed. Please try again. <br/> If the problem persists please contact The Broker Site",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Message sent",
        })
        this.closeReplyModal();
      }
    },
    closeReplyModal() {
      this.doShowReplyModal = false;

      // Reset on next frame
      // https://vee-validate.logaretm.com/v2/guide/components/validation-observer.html#validate-before-submit
      requestAnimationFrame(() => {
        this.$refs.sendMessageObserver.reset();
      });
    },
    toFreeTrialPage() {
      // this.$router.push({name: `freeTrial`});
      this.$router.push({name: `payment`});
    },
    checkIfCompanyIsFavorite() {
      this.companyIsFavorite = this.user.favCompanies.includes(this.broadcast.companyId)
      return this.companyIsFavorite
    },

    async setCompAsFavorite(sw) {
      const favoriteDTO = {'companyId': this.broadcast.companyId, 'byContactId': this.user.id, 'action': sw};
      const resp = await this.setAsFavorite(favoriteDTO)

      let bodyMsgFail = ''
      let bodyMsgSuccess = ''

      if (sw) {
        bodyMsgFail = "This Company was not added as favorite. Please try again. <br/> If the problem persists please contact The Broker Site"
        bodyMsgSuccess = "This Company was saved in your Favorites."
        this.companyIsFavorite = true;
      } else {
        bodyMsgFail = "This Company was not removed from your favorites. Please try again. <br/> If the problem persists please contact The Broker Site"
        bodyMsgSuccess = "This Company was removed from your Favorites."
        this.companyIsFavorite = false;
      }

      if (resp.data.status !== 200) {
        // if (sw) {
        // 	this.user.favCompanies.push(this.broadcast.companyId)
        // } else {
        // 	const index = this.user.favCompanies.indexOf(this.broadcast.companyId)
        // 	if (index !== -1) this.user.favCompanies.splice(index, 1)
        // }

        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: bodyMsgFail,
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: bodyMsgSuccess,

        })
      }
    },
    navToEscrow() {
      return window.open(this.$router.resolve({path: `/escrow?bcId=${this.broadcast.id}`}).href, '_blank');
    },
    addBroadcastDetailSchema() {

      const plainTextMessage = this.broadcast.message ? this.broadcast.message.replace(/<[^>]*>/g, '').substring(0, 200) : '';
      
      const schema = {
          "@context": "https://schema.org",
          "@type": "DiscussionForumPosting",
          "name": `${this.broadcast.broadcastListName} Broadcast`,
          "text": plainTextMessage,
          "dateCreated": this.broadcast.date,
          "url": `https://www.thebrokersite.com/broadcasts/${this.broadcast.id}`,
          "author": {
              "@type": "Organization",
              "name": this.broadcast.company?.name,
              "description": this.broadcast.company?.description ? this.broadcast.company?.description.substring(0, 150) : undefined,
              "url": this.broadcast.company?.website,
              ...(this.broadcast.company?.isTrusted && {
                  "additionalProperty": [{
                      "@type": "PropertyValue",
                      "name": "Trusted Member",
                      "value": "Yes"
                  }]
              })
          },
          "about": {
              "@type": "Product",
              "name": this.broadcast.description || this.broadcast.subject,
              "brand": {
                  "@type": "Brand",
                  "name": this.broadcast.brand
              },
              "category": this.broadcast.broadcastListName,
          },
      };

      useSchemaOrg(schema);
    },
    async fetchImages() {
      const response = await axios.get(`/api/broadcasts/fetchimages/${this.broadcast.id}`)
      this.broadcastImages = response.data.images
    },
    imageSrc(img) {
      return `https://www.thebrokersite.com/images/broadcast/${this.broadcast.id}/${img}`;
    },
    openModal(img, index) {
      this.selectedImage = img;
      this.currentIndex = index;
      this.showModal = true;
      this.imageReady = false;

      // reset zoom state
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
    },
    closeModal() {
      this.showModal = false;
    },
    handleZoom(e) {
      if (!e.ctrlKey) return; // only zoom when CTRL is pressed

      e.preventDefault();

      const zoomSpeed = 0.1;

      if (e.deltaY < 0) {
        // zoom in
        this.scale = Math.min(this.scale + zoomSpeed, this.maxScale);
      } else {
        // zoom out
        this.scale = Math.max(this.scale - zoomSpeed, this.minScale);
      }
    },
    startDrag(e) {
      // if (this.scale <= 1) return;

      this.isDragging = true;
      this.startX = e.clientX - this.translateX;
      this.startY = e.clientY - this.translateY;
    },
    onDrag(e) {
      if (!this.isDragging) return;

      this.translateX = e.clientX - this.startX;
      this.translateY = e.clientY - this.startY;
    },
    stopDrag() {
      this.isDragging = false;
    },
    onResize() {
      this.screenWidth = window.innerWidth;
    },
    handleKeydown(e) {
      if (!this.showModal) return; // only when modal is open

      if (e.key === 'Escape') {
        this.closeModal()
      }
      else if (e.key === 'ArrowLeft') {
        this.prevImage(); // go to previous image
      }

      else if (e.key === 'ArrowRight') {
        this.nextImage(); // go to next image
      }
    },
    resetImageScale() {
      this.imageReady = false;
      this.skipTransition = true;
      let imgScale = 1;
      const img = this.$refs.zoomImage;
      if (!img) return;

      if(this.screenWidth > 640){
        // get the image natural size
        const imgWidth = img.naturalWidth;
        const imgHeight = img.naturalHeight;
  
        // get modal size
        const modal = this.$refs.modalWrapper;
        if (!modal) return;
        
        const modalWidth = modal.clientWidth - 80; // account for padding
        const modalHeight = modal.clientHeight - 80;
        
        // Calculate scale to fit both width and height
        // Use the smaller scale to ensure image fits entirely within modal
        const scaleWidth = modalWidth / imgWidth;
        const scaleHeight = modalHeight / imgHeight;
        imgScale = Math.min(scaleWidth, scaleHeight);
        
        // Round to 2 decimal places for cleaner scaling
        imgScale = Math.floor(imgScale * 100) / 100;
  
        // Never zoom out too much (min scale = 0.1)
        imgScale = Math.max(imgScale, 0.1);
  
        // Never zoom in initially (max scale = 1) - always show full image first
        imgScale = Math.min(imgScale, 1);
      }

      this.scale = imgScale;
      this.translateX = 0;
      this.translateY = 0;
      
      // re-enable transition in next tick
      this.$nextTick(() => {
        this.imageReady = true;
        this.skipTransition = false;
      });
    },
    resetView() {
      // Reset the view to default (same as when first opened)
      this.resetImageScale();
    },
    nextImage() {
      if (!this.broadcastImages.length || this.broadcastImages.length == 1) return;

      this.currentIndex = (this.currentIndex + 1) % this.broadcastImages.length;
      this.changeImage();
    },
    prevImage() {
      if (!this.broadcastImages.length || this.broadcastImages.length == 1) return;

      this.currentIndex = (this.currentIndex - 1 + this.broadcastImages.length) % this.broadcastImages.length;
      this.changeImage();
    },

    changeImage() {
      this.imageReady = false;
      this.selectedImage = this.imageSrc(
        this.broadcastImages[this.currentIndex]
      );
      
      // Reset scale and position - resetImageScale will calculate proper fit when image loads
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.imageReady = true;
      // imageReady will be set to true by resetImageScale() after image loads
    },
  goToCreatePurchaseOrder() {
      return window.open(this.$router.resolve({ path: `/purchase-orders/create?bcId=${this.broadcast.id}` }).href, '_blank');
    }
  },
}
</script>
